module.exports = __webpack_public_path__ + "static/media/zing-icon.e0dc7168.webp";